import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import { Form } from "informed";
import { useCreateAccount } from "../../../peregrine/talons/CreateAccount/useCreateAccount";
import Button from "../Button";
import Field from "../Field";
import defaultClasses from "./createAccount.module.scss";
import FormError from "@overrides_venia/venia-ui/components/FormError";
import Password from "../Password";
import Checkbox from "../Checkbox";
import UIkit from "uikit";
import LoadingIndicator from "../LoadingIndicator";
import { useIntl } from "react-intl";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { SimpleField } from "@Components/FormFields/SimpleField";
import DobField from "@Components/FormFields/DobField";
import { handleDisabledButtonClick, isEmailValid, isPasswordValid, isTelephoneNumberValid } from "@Src_main/utils/generalUtils";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { MarketingConsentChoices } from "@Components/PrivacyComponents/marketingConsentChoices";
import { ConsentSaveFeedback } from "@Components/PrivacyComponents/consentSaveFeedback";
export const CreateAccountFormComplete = _ref => {
  let {
    initialValues,
    onSubmit,
    isDisabled,
    onCancel
  } = _ref;
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useWindowSize();
  const [prefilledEmail, setPrefilledEmail] = useState("");
  const [marketingConsents, setMarketingConsents] = useState({
    communication: false,
    profiling: false
  });
  const handleSubmitAfterSuccess = () => {
    try {
      UIkit.offcanvas("#offcanvas-registration-dx").hide();
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const handlePrefill = event => {
      if (event.detail && event.detail.email) {
        setPrefilledEmail(event.detail.email);
      }
    };
    window.addEventListener('prefillRegistrationEmail', handlePrefill);
    return () => {
      window.removeEventListener('prefillRegistrationEmail', handlePrefill);
    };
  }, []);
  const talonProps = useCreateAccount({
    initialValues: initialValues,
    onSubmit: handleSubmitAfterSuccess,
    onCancel: onCancel
  });
  const {
    errors,
    handleSubmit,
    initialValues: formInitialValues,
    loading,
    consentSaveFailed
  } = talonProps;
  const [buttonEnable, setbuttonEnable] = useState(false);
  const [isPassOk, setPasswordValid] = useState(false);
  const [isEmailOk, setEmailValid] = useState(false);
  const [isLoyaltyOk, setIsLoyaltyValid] = useState(false);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(0);
  const classes = defaultClasses;
  const [dobValue, setDobValue] = useState("");
  const handleChange = event => {
    const loyaltyChecked = event.values.loyalty ? true : false;
    const emailValid = event.values.email && isEmailValid(event.values.email);
    const passwordValid = event.values.password && isPasswordValid(event.values.password);
    const nameValid = event.values.firstname ? true : false;
    const dobValid = dobValue ? true : false;
    const genderValid = event.values.gender ? true : false;
    const telephoneValid = isTelephoneNumberValid(event.values.telephone);
    if (loyaltyChecked) setIsLoyaltyValid(true);else setIsLoyaltyValid(false);
    if (passwordValid) setPasswordValid(true);else setPasswordValid(false);
    if (emailValid) setEmailValid(true);else setEmailValid(false);
    if (emailValid && passwordValid && loyaltyChecked && nameValid) setbuttonEnable(true);else setbuttonEnable(false);
  };
  const infoPassword = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-margin-small-bottom uk-margin-small-top ".concat(classes.infobox)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-emphasis"
  }, formatMessage({
    id: "registration.modal.info.pass"
  })));
  const passwordCorretta = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-margin-small-bottom uk-margin-small-top ".concat(classes.infobox, " ").concat(classes.infoboxSuccess)
  }, /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: "registration.modal.pass.ok"
  })));
  const feedbackPassword = isPassOk ? passwordCorretta : infoPassword;
  const submitButton = /*#__PURE__*/React.createElement("div", {
    className: "uk-container button-container_registration ".concat(classes.actions)
  }, /*#__PURE__*/React.createElement(Button, {
    id: "headerCreateAccount",
    disabled: !buttonEnable && hasAttemptedSubmit,
    color: "primary",
    fullScreen: !isMobile,
    type: "submit",
    priority: "high",
    onClick: () => {
      setHasAttemptedSubmit(hasAttemptedSubmit + 1);
    }
  }, formatMessage({
    id: "button.registration"
  })));
  useEffect(() => {
    if (!buttonEnable) {
      handleDisabledButtonClick();
    }
  }, [hasAttemptedSubmit]);
  if (consentSaveFailed) {
    return /*#__PURE__*/React.createElement(ConsentSaveFeedback, _extends({
      context: "registration"
    }, talonProps));
  }
  return loading ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    global: false
  }) : /*#__PURE__*/React.createElement(Form, {
    className: "form-container_registration uk-flex uk-flex-column",
    initialValues: initialValues,
    onSubmit: values => handleSubmit(_objectSpread(_objectSpread({}, values), marketingConsents), dobValue),
    onChange: handleChange,
    id: "form-create-account",
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(FormError, {
    errors: Array.from(errors.values()),
    id: "create-account"
  }), /*#__PURE__*/React.createElement(SimpleField, {
    id: "emailField",
    label: "input.email",
    type: "email",
    name: "email",
    value: prefilledEmail,
    prefill: prefilledEmail ? true : false,
    readOnly: prefilledEmail ? true : false,
    disabled: prefilledEmail ? true : false,
    invalid: !isEmailOk && hasAttemptedSubmit,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(Password, {
    fieldName: "password",
    isToggleButtonHidden: false,
    label: "input.password",
    id: "passwordRegistration",
    invalid: !isPassOk && hasAttemptedSubmit,
    showInvalid: hasAttemptedSubmit
  }), feedbackPassword, /*#__PURE__*/React.createElement(SimpleField, {
    label: "input.name",
    name: "firstname",
    required: true,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(DobField, {
    value: dobValue,
    setValue: setDobValue,
    required: false,
    showInvalid: hasAttemptedSubmit,
    note: formatMessage({
      id: "note.birthday.field"
    })
  }), /*#__PURE__*/React.createElement(SimpleField, {
    label: "input.phone.number",
    name: "telephone",
    type: "tel",
    note: formatMessage({
      id: "note.phone.field"
    }),
    required: false,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement("div", {
    className: "privacy-container ".concat(isMobile ? "uk-margin-bottom" : "")
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    field: "loyalty",
    name: "loyalty-account",
    label_normal: formatMessage({
      id: "registration.modal.loyalty.policy"
    }),
    rootClassName: isLoyaltyOk ? "" : "shake-incomplete"
  })), /*#__PURE__*/React.createElement(MarketingConsentChoices, {
    idPrefix: "registration-consent",
    consents: marketingConsents,
    onChange: setMarketingConsents
  })), submitButton);
};